import encode from '../utils/encode.js'
import util from '../utils/util.js'
// 排序的函数
export default {
  objKeySort: function(arys) {
    // 先用Object内置类的keys方法获取要排序对象的属性名数组，再利用Array的sort方法进行排序
    var newkey = Object.keys(arys).sort()
    var newObj = '' // 创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
      if (util.isDef(arys[newkey[i]]) && arys[newkey[i]] !== null && arys[newkey[i]] !== '') {
        // 遍历newkey数组
        var value = uni.$u.test.array(arys[newkey[i]]) ? '/a' : arys[newkey[i]]
        newObj += [newkey[i]] + '=' + value + '&'
      }
    }
    return encode(newObj.substring(0, newObj.length - 1))
  }
}



// WEBPACK FOOTER //
// ./src/utils/sortingArray.js